import React, { useState } from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import {
  Card,
  CardHeader,
  CardActions,
  CardTitle,
  CardBody,
  Dropdown,
  DropdownItem,
  DropdownSeparator,
  KebabToggle,
  Label,
  TextContent,
  Text,
  TextVariants,
  TextList,
  TextListItem,
} from "@patternfly/react-core";
import { PencilAltIcon } from "@patternfly/react-icons";
import ProductLinkEditModal from "../general/ProductLinkEditModal";
import DeleteConfirmationModal from "../general/DeleteConfirmationModal";
import PublishConfirmationModal from "../general/PublishConfirmationModal";

const ProductGroupCard = (props) => {
  const productGroup = props.productGroup;
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [productGroupToDelete, setProductGroupToDelete] = useState({});
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
  const [productGroupToPublish, setProductGroupToPublish] = useState({});
  const [isEditProduct, setIsEditProduct] = useState(false);
  const [isProductLinkModalOpen, setIsProductLinkModalOpen] = useState(false);
  const [productToEdit, setProductToEdit] = useState({});

  function handleDeleteModalToggle() {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  }
  function handlePublishModalToggle() {
    setIsPublishModalOpen(!isPublishModalOpen);
  }
  function handleProductLinkModalOpen() {
    setIsProductLinkModalOpen(!isProductLinkModalOpen);
  }

  function onToggle(isOpen) {
    setIsOpen(isOpen);
  }

  function onSelect(event) {
    setIsOpen(!isOpen);
  }

  function onClickPulish(productGroup) {
    setProductGroupToPublish(productGroup);
    setIsPublishModalOpen(true);
  }

  function onClickDelete(productGroup) {
    setProductGroupToDelete(productGroup);
    setIsDeleteModalOpen(true);
  }

  function onClickEditProduct() {
    setIsEditProduct(!isEditProduct);
  }

  function onClickEditPencil(product) {
    setIsProductLinkModalOpen(true);
    setProductToEdit(product);
  }

  const renderLinks = (product) => {
    if (!isEmpty(product.link) && !isEmpty(product.related_links)) {
      return (
        <div>
          <Text component={TextVariants.a} isVisitedLink href={product.link}>
            Life Cycle
          </Text>
          &nbsp;|&nbsp;
          <Text
            component={TextVariants.a}
            isVisitedLink
            href={product.related_links}
          >
            Support Policies
          </Text>
        </div>
      );
    } else {
      if (!isEmpty(product.link)) {
        return (
          <Text component={TextVariants.a} isVisitedLink href={product.link}>
            Life Cycle
          </Text>
        );
      } else if (!isEmpty(product.related_links)) {
        return (
          <Text
            component={TextVariants.a}
            isVisitedLink
            href={product.related_links}
          >
            Support Policies
          </Text>
        );
      }
    }
  };

  const renderOtherLinks = (product) => {
    if (!isEmpty(product.other_links)) {
      return product.other_links.map((link, index) => (
        <TextList key={`other_link_${index}`}>
          <TextListItem>
            <Text component={TextVariants.a} isVisitedLink href={link.href}>
              {link.name}
            </Text>
          </TextListItem>
        </TextList>
      ));
    }
  };

  const dropdownItems = [
    <DropdownItem
      key="edit"
      component={
        <Link to={`/product/group/${productGroup.id}/edit`}>Edit</Link>
      }
    ></DropdownItem>,
    <DropdownItem
      key="editProduct"
      component="button"
      onClick={() => onClickEditProduct()}
    >
      {isEditProduct ? "Hide product editor" : "Show product editor"}
    </DropdownItem>,
    <DropdownSeparator key="separator 1" />,
    <DropdownItem
      key="publish"
      component="button"
      onClick={() => onClickPulish(productGroup)}
    >
      {productGroup.is_draft ? "Publish this group" : "Draft this group"}
    </DropdownItem>,
    <DropdownSeparator key="separator 2" />,
    <DropdownItem
      key="delete"
      component="button"
      onClick={() => onClickDelete(productGroup)}
    >
      Delete
    </DropdownItem>,
  ];

  return (
    <>
      <Card style={{ height: "100%" }} className="productGroupCard">
        <CardHeader>
          <CardActions>
            <Dropdown
              onSelect={onSelect}
              toggle={<KebabToggle onToggle={onToggle} />}
              isOpen={isOpen}
              isPlain
              dropdownItems={dropdownItems}
              position={"right"}
            />
          </CardActions>
          <CardTitle>
            {productGroup.name}
            <div>{productGroup.is_draft && <Label>Draft</Label>}</div>
          </CardTitle>
        </CardHeader>
        <CardBody>
          <TextContent>
            {productGroup.products.map((product) => (
              <TextList key={`product-list-${product.name}`}>
                <TextListItem>
                  {product.name}
                  {isEditProduct && (
                    <PencilAltIcon
                      style={{ marginLeft: "1rem" }}
                      onClick={() => {
                        onClickEditPencil(product);
                      }}
                    />
                  )}
                  {(!isEmpty(product.link) ||
                    !isEmpty(product.related_links)) && (
                    <TextList>
                      <TextListItem>{renderLinks(product)}</TextListItem>
                    </TextList>
                  )}
                  {renderOtherLinks(product)}
                </TextListItem>
              </TextList>
            ))}
          </TextContent>
        </CardBody>
      </Card>
      <DeleteConfirmationModal
        name={`${productGroupToDelete.name}`}
        type={"product group"}
        productGroupId={productGroupToDelete.id}
        isModalOpen={isDeleteModalOpen}
        handleModalToggle={handleDeleteModalToggle}
      />
      <PublishConfirmationModal
        productGroup={productGroupToPublish}
        type={"product group"}
        isModalOpen={isPublishModalOpen}
        handleModalToggle={handlePublishModalToggle}
      />
      <ProductLinkEditModal
        product={productToEdit}
        isModalOpen={isProductLinkModalOpen}
        handleModalToggle={handleProductLinkModalOpen}
      />
    </>
  );
};

export default ProductGroupCard;
